// extracted by mini-css-extract-plugin
module.exports = {"tableStyle":"style_tableStyle__1mebk"};